export default "__VITE_ASSET__Bx_KJtu0__"